import React from 'react';
import PropTypes from 'prop-types';
import {
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import routeConstants from './routeConstants';
import Login from '../pages/Login/Login';
import SearchStats from '../pages/SearchStats/SearchStats';
import LeadsStats from '../pages/LeadsStats/LeadsStats';
import ImpressionStats from '../pages/ImpressionStats/ImpressionStats';
import CompanyStats from '../pages/CompanyStats/CompanyStats';
import CompanyReport from '../pages/CompanyReport/CompanyReport';

const Routes = ({ history }) => (
    <ConnectedRouter history={history}>
        <Switch>
            <Route exact path={routeConstants.LOGIN} component={Login} />
            <Route exact path={routeConstants.SEARCH_STATS} component={SearchStats} />
            <Route exact path={routeConstants.LEADS_STATS} component={LeadsStats} />
            <Route exact path={routeConstants.IMPRESSION_STATS} component={ImpressionStats} />
            <Route exact path={routeConstants.COMPANY_STATS} component={CompanyStats} />
            <Route exact path={routeConstants.COMPANY_REPORT} component={CompanyReport} />
            <Redirect to={routeConstants.COMPANY_REPORT} />
        </Switch>
    </ConnectedRouter>
);

Routes.propTypes = {
    history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Routes;
